import { useSwapContext } from "@src/contexts";
import { Balances } from "@src/interfaces";
import { TokenWithChain } from "@src/models";
import { useMemo } from "react";

interface Props {
  token?: TokenWithChain;
  precision?: number;
}

const zeroBalances = {
  wei: "0",
  humanReadable: "0",
  abbreviated: "0",
};

export const useTokenBalance = ({ token }: Props) => {
  const { tokensBalances } = useSwapContext();
  const balances: Balances = useMemo(
    () =>
      token
        ? tokensBalances[token?.chainId]?.[token?.address] || zeroBalances
        : zeroBalances,
    [token, tokensBalances],
  );

  return balances;
};
